export function ExpandSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/expand.svg'"></ng-include>`
    }
}